import { formatDateTimeChart, useGet } from '@threatadvisor/react-utils';
import { CasesMetrics } from '@threatadvisor/react-utils/src/types/generated.SecurityEvent';
import React, { ReactElement } from 'react';
import { Descriptions } from 'antd';

export type DetectionCaseStatisticsTableProps = {
  clientUid: string;
  reportStart: string;
  reportEnd: string;
  securityEventApi: string;
};

export default function DetectionCaseStatisticsTable(
  props: DetectionCaseStatisticsTableProps
): ReactElement {
  const { clientUid, reportStart, reportEnd, securityEventApi } = props;

  const { data: casesMetrics } = useGet<CasesMetrics>(
    `${securityEventApi}/report/statusreport/cases/metrics`,
    {
      query: {
        clientUid: clientUid,
        startDate: reportStart,
        endDate: reportEnd
      }
    }
  );

  return (
    <>
      <h2 className="text-uppercase">Detection Case Statistics</h2>

      {casesMetrics ? (
        <Descriptions>
          <Descriptions.Item label="Number of Investigations">
            {casesMetrics.count}
          </Descriptions.Item>
          <Descriptions.Item label="Number of Non-Incidents">
            {casesMetrics.non_incidents}
          </Descriptions.Item>
          <Descriptions.Item label="Number of Incidents">
            {casesMetrics.incidents}
          </Descriptions.Item>
          <Descriptions.Item label="Average Daily Volume">
            {casesMetrics.avg_daily_volume}
          </Descriptions.Item>
          <Descriptions.Item label="Average Time to Escalation">
            {casesMetrics.time_to_escalation < 1
              ? '< 1'
              : formatDateTimeChart(casesMetrics.time_to_escalation, false)}
          </Descriptions.Item>
        </Descriptions>
      ) : null}
    </>
  );
}
